import { inject, Injectable } from '@angular/core';
import { ModuleHistoryStore } from '@core/stores/module-history.store';
import { TableStore } from '@rcp/common-web';
import { TabsStore } from '@core/stores/tabs.store';
import { FormStore } from '@core/stores/form.store';
import { GeneralStore } from '@core/stores/general.store';

@Injectable({
    providedIn: 'root',
})
export class StateClearService {
    readonly store = inject(ModuleHistoryStore);
    readonly tableStore = inject(TableStore);
    readonly tabsStore = inject(TabsStore);
    readonly formStore = inject(FormStore);
    readonly generalStore = inject(GeneralStore);

    constructor() {}

    deleteSavedStateExceptRoutes() {
        this.tableStore.deleteAllTables();
        this.tabsStore.deleteAllTabs();
        this.formStore.deleteAllForms();
        this.generalStore.deleteAll();
    }

    deleteAllSavedState() {
        this.store.deleteSavedRoutes();
        this.tableStore.deleteAllTables();
        this.tabsStore.deleteAllTabs();
        this.formStore.deleteAllForms();
        this.generalStore.deleteAll();
    }
}
